import { SMALL_DEVICE_WIDTH } from "./constants";

export const SMALL_DEVICES = `@media only screen and (max-width: ${SMALL_DEVICE_WIDTH}px)`;